export default __webpack_public_path__ + "static/manifest-logo-d256dd596804ad32b37ea35d94ffbbd6.svg";